import { formatBotDuration } from './botTimers.js';

const validStartedAt = (value, now = Date.now()) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 && parsed <= now ? parsed : null;
};

export const hydrateRunningBotTimer = (bot, { now = Date.now() } = {}) => {
    if (!bot || bot.status !== 'running') return bot;
    const startedAt = validStartedAt(bot.started_at, now);
    if (startedAt === null) {
        bot.started_at = null;
        bot.__startedAtMs = null;
        bot.__elapsedMs = 0;
        bot.duration = null;
        return bot;
    }
    bot.started_at = startedAt;
    bot.__startedAtMs = startedAt;
    bot.__elapsedMs = 0;
    bot.duration = formatBotDuration(Math.max(0, now - startedAt));
    return bot;
};

export const applyRunningSnapshotTimer = (bot, snapshot, now = Date.now()) => {
    if (snapshot.status === 'running') {
        const incomingStartedAt = validStartedAt(snapshot.started_at, now);
        const currentStartedAt = validStartedAt(bot.started_at, now);
        const startedAt = incomingStartedAt ?? currentStartedAt;
        const duration = startedAt !== null
            ? formatBotDuration(Math.max(0, now - startedAt))
            : null;
        let changed = false;
        if (bot.started_at !== startedAt) {
            bot.started_at = startedAt;
            changed = true;
        }
        if (bot.__startedAtMs !== startedAt) {
            bot.__startedAtMs = startedAt;
            changed = true;
        }
        bot.__elapsedMs = 0;
        if (bot.duration !== duration) {
            bot.duration = duration;
            changed = true;
        }
        return changed;
    }
    if (!Object.hasOwn(snapshot, 'started_at')) return false;
    const startedAt = snapshot.started_at ?? null;
    let changed = false;
    if (bot.started_at !== startedAt) {
        bot.started_at = startedAt;
        changed = true;
    }
    if (bot.__startedAtMs !== null) {
        bot.__startedAtMs = null;
        changed = true;
    }
    return changed;
};

export const preserveRunningBotTimer = (incoming, current, now = Date.now()) => {
    if (incoming?.status !== 'running' || current?.status !== 'running') return incoming;
    const currentStartedAt = validStartedAt(current.started_at, now);
    const incomingStartedAt = validStartedAt(incoming.started_at, now);
    const startedAt = incomingStartedAt ?? currentStartedAt;
    if (startedAt !== null) {
        incoming.started_at = startedAt;
        incoming.__startedAtMs = startedAt;
        incoming.__elapsedMs = 0;
        if (incomingStartedAt !== null) {
            incoming.duration = formatBotDuration(Math.max(0, now - startedAt));
        } else if (current.duration !== undefined && current.duration !== null) {
            incoming.duration = current.duration;
        }
        return incoming;
    }
    incoming.started_at = null;
    incoming.__startedAtMs = null;
    incoming.__elapsedMs = 0;
    delete incoming.duration;
    return incoming;
};
